import React from 'react'
import useSelector from 'hooks/use-selector'
import getCostLabelShippingSelector from 'modules/shipping/redux/selectors/get-cost-label'
import './index.css'
import Modal from 'containers/Modal'
import { MODAL_ID } from 'modules/modal/redux/constants'

export default function ProductLearnMoreAboutSamplingModal ({
  isOpen,
  onClose
}) {
  logUtil('ProductLearnMoreAboutSamplingModal').debug('[start]')

  const shippingCostLabel = useSelector(getCostLabelShippingSelector())

  return (
    <>
      <Modal
        isOpen={isOpen}
        id={MODAL_ID.PRODUCT_LEARN_MORE}
        onRequestClose={onClose}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
          },
          content: {
            maxWidth: '400px',
            width: '100%',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        <div className='modal-inner'>
          <div className='modal-header'>
            <h3>Learn more about sampling</h3>
            <svg
              onClick={onClose}
              className='close-icon'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z'
                fill='#191531'
              />
            </svg>
          </div>
          <div className='modal-section'>
            <h3>How it works</h3>
            <p>Select samples and try at home with no pressure for {shippingCostLabel} and get 20% off the full size of your favorite.</p>
            <div className='video-container'>
              <video
                preload='none'
                muted
                playsInline
                webkit-playsinline='true'
                controls
                poster='https://cdn.shopify.com/s/files/1/0569/9957/5718/files/sampling.jpg?v=1698689654'
              >
                <source
                  src='https://cdn.shopify.com/videos/c/o/v/50949f3d44d248da8f65bdd00b9a31b2.mp4'
                  type='video/mp4'
                />
              </video>
            </div>
          </div>
          <div className='modal-section'>
            <svg
              width='56'
              height='57'
              className='icon-sustainability'
              viewBox='0 0 56 57'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <rect
                y='0.5'
                width='56'
                height='56'
                rx='28'
                fill='#EEFCF0'
              />
              <path
                d='M35.3761 34.9836C31.0022 39.3575 25.0492 37.7671 21.8912 34.6092C18.7333 31.4512 17.1429 25.4982 21.5168 21.1243C26.9956 15.6455 37.7304 18.77 37.7304 18.77C37.7304 18.77 40.8006 29.5591 35.3761 34.9836Z'
                fill='white'
                stroke='#191531'
                strokeWidth='1.05'
                strokeLinecap='round'
              />
              <path
                d='M33.755 33.2354C30.4445 36.5459 25.9386 35.3422 23.5484 32.9519C21.1581 30.5617 19.9544 26.0559 23.265 22.7453C27.4119 18.5984 35.537 20.9633 35.537 20.9633C35.537 20.9633 37.8608 29.1296 33.755 33.2354Z'
                fill='#A5DAAA'
              />
              <path
                d='M37.7305 18.7695L18.2698 38.2302'
                stroke='#191531'
                strokeWidth='1.05'
                strokeLinecap='round'
              />
              <path
                d='M24.228 24.0757L25.6678 30.8427L32.4348 32.2825'
                stroke='#191531'
                strokeWidth='1.05'
                strokeLinecap='round'
              />
            </svg>
            <h3>Reduce waste with sampling</h3>
            <p>
              Stop guessing and start sampling - only buy the full size of what you love, so you aren’t left with waste from products that don’t work for you. You can also utilize our reusable containers to store your favorite products while on the go, so you’ll never be left with wasted packaging.
            </p>
          </div>
        </div>
      </Modal>
    </>
  )
}
